import React from "react";

import "./IconCircle.scss";

export interface IconCircleProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  color?: "primary" | "tertiary" | "success" | "error";
  size?: "md" | "lg" | "xl";
}

function IconCircle({ icon: Icon, color = "primary", size = "md" }: IconCircleProps): JSX.Element {
  const classNames = `icon-circle icon-circle--${color} icon-circle--${size}`;
  return (
    <div className={classNames}>
      <Icon />
    </div>
  );
}

IconCircle.defaultProps = {
  color: "primary" as "primary" | "tertiary" | "success" | "error",
  size: "md" as "md" | "lg" | "xl",
};

export default IconCircle;
